import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa } from '../../security/securityContext';
import Titulo from '../comum/Titulo';

export class MenuMdfe extends Component {
  render() {
    return (
      <div className="area-home">
        <Titulo texto="MDF-e" urlRetorno="/menu-encomendas" />
        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
          getAdminEmpresa(this.props.empresaSelecionada.id),
          getGestorEmpresa(this.props.empresaSelecionada.id)]}>
          <div className="vx-quick-actions mt-3">
            <Link to="/painel-mdfe" className="vx-action-card">
              <div className="vx-action-icon-wrap c-orange">
                <span className="material-icons">local_shipping</span>
              </div>
              <div>
                <p className="vx-action-title">Transmissão MDF-e</p>
                <p className="vx-action-desc">
                  <span className="material-icons">send</span>
                  Emissão e transmissão de MDF-e
                </p>
              </div>
            </Link>
          </div>
        </Autorizacao>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    authentication: state.authentication
  }
}

export default withRouter(connect(mapStateToProps, {})(MenuMdfe));
